import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui';

type ConfirmDeleteModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	description: ReactNode;
	/** Texto do botão principal (padrão: exclusão). */
	confirmButtonText?: string;
	disableConfirm?: boolean;
};

export const ConfirmDeleteModal = ({
	isOpen,
	onClose,
	onConfirm,
	title,
	description,
	confirmButtonText = 'Confirmar exclusão',
	disableConfirm = false,
}: ConfirmDeleteModalProps) => {
	if (!isOpen) return null;

	return createPortal(
		<div className="fixed inset-0 z-[10000] flex items-center justify-center p-4">
			<div
				className="absolute inset-0 bg-stone-900/60 backdrop-blur-[2px]"
				onClick={onClose}
			/>
			<div className="animate-in zoom-in-95 relative w-full max-w-[400px] rounded-[2rem] bg-white p-8 text-center shadow-2xl duration-200">
				<div className="mb-4 flex justify-center text-rose-500">
					<div className="rounded-full bg-rose-50 p-4">
						<AlertTriangle size={32} />
					</div>
				</div>
				<h3 className="mb-2 text-xl font-black text-stone-900">
					{title}
				</h3>
				<div className="mb-8 text-sm font-medium leading-relaxed text-stone-500">
					{description}
				</div>
				<div className="flex flex-col gap-3">
					<Button
						text={confirmButtonText}
						className="w-full justify-center rounded-full border-none bg-rose-600 py-3 font-bold text-white shadow-md hover:bg-rose-700 disabled:opacity-60"
						onClick={onConfirm}
						disabled={disableConfirm}
					/>
					<button
						type="button"
						onClick={onClose}
						className="text-sm font-bold text-stone-400 transition-colors hover:text-stone-600"
					>
						Cancelar
					</button>
				</div>
			</div>
		</div>,
		document.body,
	);
};
